import { popularPagesHideRequestMessage, popularPagesShowRequestMessage } from "app/actions/popularPagesActions";
import { radioItems } from "app/components/React/PopularPagesFilters/popularPagesFilters.config";
import * as _ from "lodash";
import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import { PopularPagesTableWidgetFilters } from "../widget-filters/PopularPagesTableWidgetFilters";
import { TableWidget } from "./TableWidget";

export class PopularPagesTableWidget extends TableWidget {
    public static getWidgetMetadataType() {
        return "PopularPagesTable";
    }

    public static getWidgetResourceType() {
        return "Table";
    }

    public static getWidgetDashboardType() {
        return "Table";
    }

    public static getFiltersComponent() {
        return PopularPagesTableWidgetFilters;
    }

    constructor() {
        super();
    }

    public onWidgetMount() {
        if (!this.dashboardId) {
            this._events.on(
                "widgetGetDataFail",
                _.debounce((data) => {
                    this._reduxService.dispatch(
                        popularPagesShowRequestMessage(this.apiParams.keys, data.headers("error-code") === "5001"),
                    );
                }, 100),
            );
            this._events.on(
                "widgetGetDataSuccess",
                _.debounce(() => {
                    this._reduxService.dispatch(popularPagesHideRequestMessage(this.apiParams.keys));
                }, 100),
            );
            this._events.on(
                "widgetCleanup",
                _.debounce(() => {
                    this._reduxService.dispatch(popularPagesHideRequestMessage(this.apiParams.keys));
                }, 100),
            );
        }
    }

    public getWidgetFilters() {
        const filterNames = radioItems.map((radioItem) => radioItem.value);
        filterNames.push("isUtm");
        filterNames.push("filter");
        const filters = {};
        Object.keys(this.apiParams).map((apiParamName) => {
            if (filterNames.indexOf(apiParamName) > -1) {
                filters[apiParamName] = this.apiParams[apiParamName];
            }
        });
        return filters;
    }

    public getSearchKey() {
        return "Page";
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }
}

PopularPagesTableWidget.register();
